import React from 'react'
import "./aboutus.css"
import GOTH from "../Assets/aboutus.jpg"
import { FaAward } from 'react-icons/fa'
import { FiUsers } from 'react-icons/fi'
import { VscFolderLibrary } from 'react-icons/vsc'
import { Link } from 'react-router-dom'
import { motion } from "framer-motion"

const Loadvariants = {
  hidden: { opacity: 0,
  },
  visible: { opacity: 1,
     transition: {
          type: "spring",
          duration: 7
     },
  }
}
const AboutUs = () => {
  return (
    <section id="about">
            <h5>Get To Know</h5>
            <h2>About Us</h2>


            <motion.div className="container about__container"
              initial="hidden"
              animate="visible"
              exit={{
                x: "-100vw",
               transition:{ ease: 'easeInOut'}
              }}
              variants={Loadvariants}
            >
                <div className="about__me">
                           <div className="about__me-image">
                                   <img src={GOTH} />
                           </div>
                </div>

                <div className="about__content">
                                  <div className="about__cards">
                                          <articule   className="about__card" data-aos="zoom-in">
                                              <FaAward  className="about__icon"/>
                                              <h5>Experience</h5>
                                              <small>2+ years Working</small>
                                          </articule>

                                          <section   className="about__card" data-aos="zoom-in">
                                              <FiUsers  className="about__icon"/>
                                              <h5>Customers</h5>
                                              <small>Over 100+ Worldwide</small>
                                          </section>

                                          <section   className="about__card" data-aos="zoom-in">
                                              <VscFolderLibrary  className="about__icon"/>
                                              <h5>Reviews</h5>
                                              <small>Over 80+ Positive reviews</small>
                                          </section>
                                  </div>

                                  <p>Welcome to Gamersmart, your number one source for all games an accessories. we are dedicated to giving you the very best of product, with a focus on uniqueness, customer service and having fun.</p>

                                  <Link to="/contact" className="btn btn-primary">Let's Talk</Link>
                </div>
            </motion.div>
        </section>
  )
}

export default AboutUs